import { useState } from 'react';
import { Send } from 'lucide-react';
import { chatClient } from '@/services/chat-client';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const SENDER_UID = `web-${Date.now()}`;
const SENDER_CALLSIGN = 'WebUser';

interface ChatRoomInputProps {
  roomId: string;
}

/** Simple send-only input for room-based chat */
export function ChatRoomInput({ roomId }: ChatRoomInputProps): React.JSX.Element {
  const [value, setValue] = useState('');

  async function handleSend(): Promise<void> {
    const content = value.trim();
    if (!content || !roomId) return;
    setValue('');
    await chatClient.sendMessage(roomId, SENDER_UID, SENDER_CALLSIGN, content);
  }

  function handleKeyDown(e: React.KeyboardEvent): void {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  }

  return (
    <div className="flex gap-2 border-t border-echo-border pt-3">
      <Input
        className="flex-1"
        placeholder="Type a message..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <Button size="icon" onClick={handleSend} disabled={!value.trim()} title="Send message">
        <Send className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
